import { useMutation } from '@tanstack/vue-query'

import demo from '@/assets/demo'
import { request } from '@/server/core/request'

export const MUTATE_KEY = 'MUTATE_INSURANCE_EXCEL'

interface InvalidData {
    row: number
    insNo: string
    errorkeys: string[]
    missingKeys: string[]
}
interface PostInsuranceExcelResponse {
    products: any[]
    insurances: any[]
    invalidData: InvalidData[]
}

async function postInsuranceExcel(data: FormData) {
    if (data) return demo.mutateInsurancePDF
    return new Promise<PostInsuranceExcelResponse>((resolve, reject) => {
        request('POST', `/api/excel`, {
            data,
            contentType: 'multipart/form-data'
        })
            .then((res) => {
                resolve(res.data)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export default function mutationInsuranceExcel() {
    return useMutation({
        mutationKey: [MUTATE_KEY],
        mutationFn: (payload: any) => postInsuranceExcel(payload)
    })
}
